import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	starIcon: {
		color: theme.palette.primary.main
	}
}));
